export default {
  getVideos: state => state.videos,
  getSelectedVideo: state => state.selectedVideo,
  getVideoUploadingStatus: state => state.videoUploadingStatus
}
